module.exports = __webpack_public_path__ + "img/story032@2x.db1c1433.webp";